import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, esUrl, showModalPageClass, hideModalPageClass} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import ModalMultimedia from '../../../../Partials/ModalMultimedia';

export default class AdmDetallePerfilador extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            tituloLongitud:0,
            tooltipLongitud:0,
            descripcionLongitud:0,
            tituloEnlace1Longitud:0,
            tituloEnlace2Longitud:0,
            tituloEnlace3Longitud:0,   
            colorLongitud:0, 
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,
                mdpe_Titulo:"",
                mdpe_ContenidoTooltip:"",
                mdpe_Descripcion:"",
                mdpe_ImagenPortada1:"",
                mdpe_ImagenPortada2:"",
                mdpe_ImagenPortadaMovil1:"",
                mdpe_ImagenPortadaMovil2:"",
                mdpe_TituloEnlace1:"",
                mdpe_Enlace1:"",
                mdpe_TituloEnlace2:"",
                mdpe_Enlace2:"",
                mdpe_TituloEnlace3:"",
                mdpe_Enlace3:"",
                mdpe_ColorFondo:"",
                mdpe_PosicionIzquiedaDerecha:0,
                mdpe_Activo:true,
                pweb_Id:0
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,
                mdpe_Id:0,
                mdpe_Titulo:"",
                mdpe_ContenidoTooltip:"",
                mdpe_Descripcion:"",
                mdpe_ImagenPortada1:"",
                mdpe_ImagenPortada2:"",
                mdpe_ImagenPortadaMovil1:"",
                mdpe_ImagenPortadaMovil2:"",
                mdpe_TituloEnlace1:"",
                mdpe_Enlace1:"",
                mdpe_TituloEnlace2:"",
                mdpe_Enlace2:"",
                mdpe_TituloEnlace3:"",
                mdpe_Enlace3:"",
                mdpe_ColorFondo:"",
                mdpe_PosicionIzquiedaDerecha:0,
                pweb_Id:0
            },
            Validacion: {
                mdpe_Titulo: {
                    Error: false,                    
                },
                mdpe_ContenidoTooltip: {
                    Error: false,                    
                },
                mdpe_Descripcion: {
                    Error: false,                    
                },
                mdpe_ImagenPortada1: {
                    Error: false,                    
                },
                mdpe_ImagenPortada2: {
                    Error: false,                    
                },
                mdpe_ImagenPortadaMovil1: {
                    Error: false,                    
                },
                mdpe_ImagenPortadaMovil2: {
                    Error: false,                    
                },
                mdpe_TituloEnlace1: {
                    Error: false,                    
                },
                mdpe_Enlace1: {
                    Error: false,                    
                },
                mdpe_TituloEnlace2: {
                    Error: false,                    
                },
                mdpe_Enlace2: {
                    Error: false,                    
                },
                mdpe_TituloEnlace3: {
                    Error: false,                    
                },
                mdpe_Enlace3: {
                    Error: false,                    
                },
                mdpe_ColorFondo: {
                    Error: false,                    
                },
                pweb_Id: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mdpe_Titulo: {
                    Error: false,                    
                },
                mdpe_ContenidoTooltip: {
                    Error: false,                    
                },
                mdpe_Descripcion: {
                    Error: false,                    
                },
                mdpe_ImagenPortada1: {
                    Error: false,                    
                },
                mdpe_ImagenPortada2: {
                    Error: false,                    
                },
                mdpe_ImagenPortadaMovil1: {
                    Error: false,                    
                },
                mdpe_ImagenPortadaMovil2: {
                    Error: false,                    
                },
                mdpe_TituloEnlace1: {
                    Error: false,                    
                },
                mdpe_Enlace1: {
                    Error: false,                    
                },
                mdpe_TituloEnlace2: {
                    Error: false,                    
                },
                mdpe_Enlace2: {
                    Error: false,                    
                },
                mdpe_TituloEnlace3: {
                    Error: false,                    
                },
                mdpe_Enlace3: {
                    Error: false,                    
                },
                mdpe_ColorFondo: {
                    Error: false,                    
                },
                pweb_Id: {
                    Error: false,                    
                }
            },
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:""
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
    }

    getResponseMultimedia = (urlSeleccionada) => {

        let resource = this.state.isEditfieldReturnMultimedia ? this.state.resourceEdit : this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
            
            if(this.state.isEditfieldReturnMultimedia){
                this.setState({resourceEdit:resource, fieldReturnMultimedia:"", isEditfieldReturnMultimedia:false});
            }else{
                this.setState({resource:resource, fieldReturnMultimedia:""});
            }
        }
    
        hideModalPageClass("divGestorArchivosDetPerfilador");
    }
    
    showModalMultimedia = (clase = "", campo = "", isEdition = false) => {
        this.setState({fieldReturnMultimedia:campo, isEditfieldReturnMultimedia:isEdition});
        showModalPageClass(clase);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let tooltipLongitud = this.state.tooltipLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;
        let tituloEnlace1Longitud = this.state.tituloEnlace1Longitud;
        let tituloEnlace2Longitud = this.state.tituloEnlace2Longitud;
        let tituloEnlace3Longitud = this.state.tituloEnlace3Longitud;
        let colorLongitud = this.state.colorLongitud;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mdpe_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mdpe_ContenidoTooltip'){
            tooltipLongitud = value.length;
        }
        if(target.name == 'mdpe_Descripcion'){
            descripcionLongitud = value.length;
        }
        if(target.name == 'mdpe_TituloEnlace1'){
            tituloEnlace1Longitud = value.length;
        }
        if(target.name == 'mdpe_TituloEnlace2'){
            tituloEnlace2Longitud = value.length;
        }
        if(target.name == 'mdpe_TituloEnlace3'){
            tituloEnlace3Longitud = value.length;
        }
        if(target.name == 'mdpe_ColorFondo'){
            colorLongitud = value.length;
        }

        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            tooltipLongitud: tooltipLongitud,
            descripcionLongitud:descripcionLongitud,
            tituloEnlace1Longitud: tituloEnlace1Longitud,
            tituloEnlace2Longitud: tituloEnlace2Longitud,
            tituloEnlace3Longitud: tituloEnlace3Longitud,
            colorLongitud:colorLongitud,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let tooltipLongitud = this.state.tooltipLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;
        let tituloEnlace1Longitud = this.state.tituloEnlace1Longitud;
        let tituloEnlace2Longitud = this.state.tituloEnlace2Longitud;
        let tituloEnlace3Longitud = this.state.tituloEnlace3Longitud;
        let colorLongitud = this.state.colorLongitud;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mdpe_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mdpe_ContenidoTooltip'){
            tooltipLongitud = value.length;
        }
        if(target.name == 'mdpe_Descripcion'){
            descripcionLongitud = value.length;
        }
        if(target.name == 'mdpe_TituloEnlace1'){
            tituloEnlace1Longitud = value.length;
        }
        if(target.name == 'mdpe_TituloEnlace2'){
            tituloEnlace2Longitud = value.length;
        }
        if(target.name == 'mdpe_TituloEnlace3'){
            tituloEnlace3Longitud = value.length;
        }
        if(target.name == 'mdpe_ColorFondo'){
            colorLongitud = value.length;
        }

        this.setState({
            resourceEdit: copyResource,
            tituloLongitud: tituloLongitud,
            tooltipLongitud: tooltipLongitud,
            descripcionLongitud:descripcionLongitud,
            tituloEnlace1Longitud: tituloEnlace1Longitud,
            tituloEnlace2Longitud: tituloEnlace2Longitud,
            tituloEnlace3Longitud: tituloEnlace3Longitud,
            colorLongitud:colorLongitud,
            ValidacionEdit: validaciones
        });  
    }

    storeDetallePerfilador = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mdpe_Titulo == '') {              
            newState.Validacion.mdpe_Titulo = {Error: true};
            newState.hasError = true;
        }
        /* if (newState.resource.mdpe_ContenidoTooltip == '') {  
            newState.Validacion.mdpe_ContenidoTooltip = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mdpe_Descripcion == '') {              
            newState.Validacion.mdpe_Descripcion = {Error: true};
            newState.hasError = true;
        } */
        if (newState.resource.mdpe_ImagenPortada1 == '') {  
            newState.Validacion.mdpe_ImagenPortada1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mdpe_ImagenPortada2 == '') {  
            newState.Validacion.mdpe_ImagenPortada2 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resource.mdpe_ImagenPortadaMovil1 == '') {              
            newState.Validacion.mdpe_ImagenPortadaMovil1 = {Error: true};
            newState.hasError = true;
        }
        
		/* 
		if (newState.resource.mdpe_ImagenPortadaMovil2 == '') {  
            newState.Validacion.mdpe_ImagenPortadaMovil2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mdpe_TituloEnlace1 == '') {              
            newState.Validacion.mdpe_TituloEnlace1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mdpe_Enlace1 == '') {  
            newState.Validacion.mdpe_Enlace1 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resource.mdpe_TituloEnlace2 == '') {  
            newState.Validacion.mdpe_TituloEnlace2 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resource.mdpe_Enlace2 == '') {              
            newState.Validacion.mdpe_Enlace2 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resource.mdpe_TituloEnlace3 == '') {  
            newState.Validacion.mdpe_TituloEnlace3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mdpe_Enlace3 == '') {              
            newState.Validacion.mdpe_Enlace3 = {Error: true};
            newState.hasError = true;
        }
         */
		if (newState.resource.mdpe_Enlace1 !== '' && !esUrl(newState.resource.mdpe_Enlace1)) {  
            newState.Validacion.mdpe_Enlace1 = {Error: true};
            newState.hasError = true;
        }
		
		if (newState.resource.mdpe_Enlace2 !== '' && !esUrl(newState.resource.mdpe_Enlace2)) {  
            newState.Validacion.mdpe_Enlace2 = {Error: true};
            newState.hasError = true;
        }
		
		if (newState.resource.mdpe_Enlace3 !== '' && !esUrl(newState.resource.mdpe_Enlace3)) {  
            newState.Validacion.mdpe_Enlace3 = {Error: true};
            newState.hasError = true;
        }
		
        if (newState.resource.mdpe_ColorFondo == '') {  
            newState.Validacion.mdpe_ColorFondo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pweb_Id == 0) {  
            newState.Validacion.pweb_Id = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloDetallePerfiladorUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mdpe_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.mdpe_Titulo = '';
                stateResponse.resource.mdpe_ContenidoTooltip = '';
                stateResponse.resource.mdpe_Descripcion = '';
                stateResponse.resource.mdpe_ImagenPortada1 = '';
                stateResponse.resource.mdpe_ImagenPortada2 = '';
                stateResponse.resource.mdpe_ImagenPortadaMovil1 = '';
                stateResponse.resource.mdpe_ImagenPortadaMovil2 = '';
                stateResponse.resource.mdpe_TituloEnlace1 = '';
                stateResponse.resource.mdpe_Enlace1 = '';
                stateResponse.resource.mdpe_TituloEnlace2 = '';
                stateResponse.resource.mdpe_Enlace2 = '';
                stateResponse.resource.mdpe_TituloEnlace3 = '';
                stateResponse.resource.mdpe_Enlace3 = '';
                stateResponse.resource.mdpe_ColorFondo = '';
                stateResponse.resource.mdpe_PosicionIzquiedaDerecha = 0;
                stateResponse.resource.pweb_Id = 0;

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateDetallePerfilador = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mdpe_Titulo == '') {              
            newState.ValidacionEdit.mdpe_Titulo = {Error: true};
            newState.hasError = true;
        }
        /* if (newState.resourceEdit.mdpe_ContenidoTooltip == '') {  
            newState.ValidacionEdit.mdpe_ContenidoTooltip = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mdpe_Descripcion == '') {              
            newState.ValidacionEdit.mdpe_Descripcion = {Error: true};
            newState.hasError = true;
        } */
        if (newState.resourceEdit.mdpe_ImagenPortada1 == '') {  
            newState.ValidacionEdit.mdpe_ImagenPortada1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mdpe_ImagenPortada2 == '') {  
            newState.ValidacionEdit.mdpe_ImagenPortada2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mdpe_ImagenPortadaMovil1 == '') {              
            newState.ValidacionEdit.mdpe_ImagenPortadaMovil1 = {Error: true};
            newState.hasError = true;
        }
		/*
        if (newState.resourceEdit.mdpe_ImagenPortadaMovil2 == '') {  
            newState.ValidacionEdit.mdpe_ImagenPortadaMovil2 = {Error: true};
            newState.hasError = true;
        }
         if (newState.resourceEdit.mdpe_TituloEnlace1 == '') {
            newState.ValidacionEdit.mdpe_TituloEnlace1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mdpe_Enlace1 == '') {  
            newState.ValidacionEdit.mdpe_Enlace1 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resourceEdit.mdpe_TituloEnlace2 == '') {  
            newState.ValidacionEdit.mdpe_TituloEnlace2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mdpe_Enlace2 == '') {              
            newState.ValidacionEdit.mdpe_Enlace2 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resourceEdit.mdpe_TituloEnlace3 == '') {  
            newState.ValidacionEdit.mdpe_TituloEnlace3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mdpe_Enlace3 == '') {              
            newState.ValidacionEdit.mdpe_Enlace3 = {Error: true};
            newState.hasError = true;
        }
		*/
		
		if (newState.resourceEdit.mdpe_Enlace1 !== '' && !esUrl(newState.resourceEdit.mdpe_Enlace1)) {  
            newState.ValidacionEdit.mdpe_Enlace1 = {Error: true};
            newState.hasError = true;
        }
		
		if (newState.resourceEdit.mdpe_Enlace2 !== '' && !esUrl(newState.resourceEdit.mdpe_Enlace2)) {  
            newState.ValidacionEdit.mdpe_Enlace2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mdpe_Enlace3 !== '' && !esUrl(newState.resourceEdit.mdpe_Enlace3)) {  
            newState.ValidacionEdit.mdpe_Enlace3 = {Error: true};
            newState.hasError = true;
        } 
        if (newState.resourceEdit.mdpe_ColorFondo == '') {  
            newState.ValidacionEdit.mdpe_ColorFondo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.pweb_Id == 0) {  
            newState.ValidacionEdit.pweb_Id = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloDetallePerfiladorUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mdpe_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closeDetallePerfilador = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mdpe_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }

      
    loadDetallePerfilador = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloDetallePerfiladorUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resourceEdit: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){

        let mweb = 3;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadDetallePerfilador(resource.pmod_Id);
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeDetallePerfilador()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">

                        {
                            this.state.resourceEdit.mdpe_Id > 0 ?
                            <React.Fragment>
                            <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                

                                <div className="txtFile x-1">
                                    <input type="text" 
                                    placeholder="Título" 
                                    name='mdpe_Titulo' 
                                    value={this.state.resourceEdit.mdpe_Titulo} 
                                    maxLength={40} 
                                    className={this.state.ValidacionEdit.mdpe_Titulo.Error ? "error" : ""}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={40}>{this.state.tituloLongitud}/40</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="ToolTip" 
                                    name='mdpe_ContenidoTooltip' 
                                    value={this.state.resourceEdit.mdpe_ContenidoTooltip} 
                                    className={this.state.ValidacionEdit.mdpe_ContenidoTooltip.Error ? "error" : ""} 
                                    maxLength={100}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={100}>{this.state.tooltipLongitud}/100</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Resumen" 
                                    name='mdpe_Descripcion' 
                                    value={this.state.resourceEdit.mdpe_Descripcion} 
                                    className={this.state.ValidacionEdit.mdpe_Descripcion.Error ? "error" : ""} 
                                    maxLength={180}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={180}>{this.state.descripcionLongitud}/180</span>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosDetPerfilador", "mdpe_ImagenPortada1", true)}/>
                                    <input type="text" placeholder="Imagen portada 1" 
                                    name='mdpe_ImagenPortada1' 
                                    value={this.state.resourceEdit.mdpe_ImagenPortada1} 
                                    className={this.state.ValidacionEdit.mdpe_ImagenPortada1.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									
									<label className="recomendacion">
									Medida requerida para "Contenido a la derecha": 340x310 píxeles.<br />
									Medida requerida para "Contenido a la izquierda": 520x300 píxeles
									</label>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosDetPerfilador", "mdpe_ImagenPortada2", true)}/>
                                    <input type="text" placeholder="Imagen portada 2" 
                                    name='mdpe_ImagenPortada2' 
                                    value={this.state.resourceEdit.mdpe_ImagenPortada2} 
                                    className={this.state.ValidacionEdit.mdpe_ImagenPortada2.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label className="recomendacion">
									Medida requerida para "Contenido a la derecha": 340x310 píxeles.<br />
									Medida requerida para "Contenido a la izquierda": 520x300 píxeles
									</label>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosDetPerfilador", "mdpe_ImagenPortadaMovil1", true)}/>
                                    <input type="text" placeholder="Imagen portada movil 1" 
                                    name='mdpe_ImagenPortadaMovil1' 
                                    value={this.state.resourceEdit.mdpe_ImagenPortadaMovil1} 
                                    className={this.state.ValidacionEdit.mdpe_ImagenPortadaMovil1.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label className="recomendacion">Medida requerida: 450x250 píxeles.</label>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosDetPerfilador", "mdpe_ImagenPortadaMovil2", true)}/>
                                    <input type="text" placeholder="Imagen portada movil 2" 
                                    name='mdpe_ImagenPortadaMovil2' 
                                    value={this.state.resourceEdit.mdpe_ImagenPortadaMovil2} 
                                    className={this.state.ValidacionEdit.mdpe_ImagenPortadaMovil2.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label className="recomendacion">Medida requerida: 450x250 píxeles.</label>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Título enlace 1" 
                                    name='mdpe_TituloEnlace1' 
                                    value={this.state.resourceEdit.mdpe_TituloEnlace1} 
                                    className={this.state.ValidacionEdit.mdpe_TituloEnlace1.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Enlace 1" 
                                    name='mdpe_Enlace1' 
                                    value={this.state.resourceEdit.mdpe_Enlace1} 
                                    className={this.state.ValidacionEdit.mdpe_Enlace1.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Título enlace 2" 
                                    name='mdpe_TituloEnlace2' 
                                    value={this.state.resourceEdit.mdpe_TituloEnlace2} 
                                    className={this.state.ValidacionEdit.mdpe_TituloEnlace2.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Enlace 2" 
                                    name='mdpe_Enlace2' 
                                    value={this.state.resourceEdit.mdpe_Enlace2} 
                                    className={this.state.ValidacionEdit.mdpe_Enlace2.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Título enlace 3" 
                                    name='mdpe_TituloEnlace3' 
                                    value={this.state.resourceEdit.mdpe_TituloEnlace3} 
                                    className={this.state.ValidacionEdit.mdpe_TituloEnlace3.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Enlace 3" 
                                    name='mdpe_Enlace3' 
                                    value={this.state.resourceEdit.mdpe_Enlace3} 
                                    className={this.state.ValidacionEdit.mdpe_Enlace3.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Color de fondo" 
                                    name='mdpe_ColorFondo' 
                                    value={this.state.resourceEdit.mdpe_ColorFondo} 
                                    maxLength={7} 
                                    className={this.state.ValidacionEdit.mdpe_ColorFondo.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
                                </div>

                                <div className="txtFile x-1">
                                    <select name='mdpe_PosicionIzquiedaDerecha' id='mdpe_PosicionIzquiedaDerecha' 
                                    onChange={this.handleInputChangeEdit}>
                                        <option value="0" selected={(this.state.resourceEdit.mdpe_PosicionIzquiedaDerecha == 0) ? true : false}>Contenido a la izquierda</option>
                                        <option value="1" selected={(this.state.resourceEdit.mdpe_PosicionIzquiedaDerecha == 1) ? true : false}>Contenido a la derecha</option>
                                    </select>                        
                                </div>

                                <div className="txtFile x-1">
                                    <select name='pweb_Id' id='pweb_Id' 
                                    onChange={this.handleInputChangeEdit}
                                    className={this.state.ValidacionEdit.pweb_Id.Error ? "error" : ""} >
                                        <option value="0">Seleccionar Perfil 1</option>
                                        {
                                            this.state.perfiles.length > 0 ?
                                            this.state.perfiles.map((perfil) => (
                                                <option value={perfil.id} selected={(this.state.resourceEdit.pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                            ))
                                            : null
                                        }
                                    </select>                        
                                </div>

                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateDetallePerfilador(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    <div className="txtFile x-1">
                                        <input type="text" 
                                        placeholder="Título" 
                                        name='mdpe_Titulo' 
                                        value={this.state.resource.mdpe_Titulo} 
                                        maxLength={40} 
                                        className={this.state.Validacion.mdpe_Titulo.Error ? "error" : ""}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={40}>{this.state.tituloLongitud}/40</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="ToolTip" 
                                        name='mdpe_ContenidoTooltip' 
                                        value={this.state.resource.mdpe_ContenidoTooltip} 
                                        className={this.state.Validacion.mdpe_ContenidoTooltip.Error ? "error" : ""} 
                                        maxLength={100}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={100}>{this.state.tooltipLongitud}/100</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Resumen" 
                                        name='mdpe_Descripcion' 
                                        value={this.state.resource.mdpe_Descripcion} 
                                        className={this.state.Validacion.mdpe_Descripcion.Error ? "error" : ""} 
                                        maxLength={180}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={180}>{this.state.descripcionLongitud}/180</span>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosDetPerfilador", "mdpe_ImagenPortada1")}/>
                                        <input type="text" placeholder="Imagen portada 1" 
                                        name='mdpe_ImagenPortada1' 
                                        value={this.state.resource.mdpe_ImagenPortada1} 
                                        className={this.state.Validacion.mdpe_ImagenPortada1.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label className="recomendacion">
										Medida requerida para "Contenido a la derecha": 340x310 píxeles.<br />
										Medida requerida para "Contenido a la izquierda": 520x300 píxeles
										</label>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosDetPerfilador", "mdpe_ImagenPortada2")}/>
                                        <input type="text" placeholder="Imagen portada 2" 
                                        name='mdpe_ImagenPortada2' 
                                        value={this.state.resource.mdpe_ImagenPortada2} 
                                        className={this.state.Validacion.mdpe_ImagenPortada2.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label className="recomendacion">
										Medida requerida para "Contenido a la derecha": 340x310 píxeles.<br />
										Medida requerida para "Contenido a la izquierda": 520x300 píxeles
										</label>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosDetPerfilador", "mdpe_ImagenPortadaMovil1")}/>
                                        <input type="text" placeholder="Imagen portada movil 1" 
                                        name='mdpe_ImagenPortadaMovil1' 
                                        value={this.state.resource.mdpe_ImagenPortadaMovil1} 
                                        className={this.state.Validacion.mdpe_ImagenPortadaMovil1.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label className="recomendacion">Medida requerida: 450x250 píxeles.</label>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosDetPerfilador", "mdpe_ImagenPortadaMovil2")}/>
                                        <input type="text" placeholder="Imagen portada movil 2" 
                                        name='mdpe_ImagenPortadaMovil2' 
                                        value={this.state.resource.mdpe_ImagenPortadaMovil2} 
                                        className={this.state.Validacion.mdpe_ImagenPortadaMovil2.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label className="recomendacion">Medida requerida: 450x250 píxeles.</label>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Título enlace 1" 
                                        name='mdpe_TituloEnlace1' 
                                        value={this.state.resource.mdpe_TituloEnlace1} 
                                        className={this.state.Validacion.mdpe_TituloEnlace1.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Enlace 1" 
                                        name='mdpe_Enlace1' 
                                        value={this.state.resource.mdpe_Enlace1} 
                                        className={this.state.Validacion.mdpe_Enlace1.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Título enlace 2" 
                                        name='mdpe_TituloEnlace2' 
                                        value={this.state.resource.mdpe_TituloEnlace2} 
                                        className={this.state.Validacion.mdpe_TituloEnlace2.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Enlace 2" 
                                        name='mdpe_Enlace2' 
                                        value={this.state.resource.mdpe_Enlace2} 
                                        className={this.state.Validacion.mdpe_Enlace2.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Título enlace 3" 
                                        name='mdpe_TituloEnlace3' 
                                        value={this.state.resource.mdpe_TituloEnlace3} 
                                        className={this.state.Validacion.mdpe_TituloEnlace3.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Enlace 3" 
                                        name='mdpe_Enlace3' 
                                        value={this.state.resource.mdpe_Enlace3} 
                                        className={this.state.Validacion.mdpe_Enlace3.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Color de fondo" 
                                        name='mdpe_ColorFondo' 
                                        maxLength={7} 
                                        value={this.state.resource.mdpe_ColorFondo} 
                                        className={this.state.Validacion.mdpe_ColorFondo.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
                                    </div>

                                    <div className="txtFile x-1">
                                        <select name='mdpe_PosicionIzquiedaDerecha' id='mdpe_PosicionIzquiedaDerecha' 
                                        onChange={this.handleInputChange}>
                                            <option value="0" selected={(this.state.resource.mdpe_PosicionIzquiedaDerecha == 0) ? true : false}>Contenido a la izquierda</option>
                                            <option value="1" selected={(this.state.resource.mdpe_PosicionIzquiedaDerecha == 1) ? true : false}>Contenido a la derecha</option>
                                        </select>                        
                                    </div>

                                    <div className="txtFile x-1">
                                        <select name='pweb_Id' id='pweb_Id' 
                                        onChange={this.handleInputChange}
                                        className={this.state.Validacion.pweb_Id.Error ? "error" : ""} >
                                            <option value="0">Seleccionar Perfil 1</option>
                                            {
                                                this.state.perfiles.length > 0 ?
                                                this.state.perfiles.map((perfil) => (
                                                    <option value={perfil.id} key={perfil.id} selected={(this.state.resource.pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                                ))
                                                : null
                                            }
                                        </select>                        
                                    </div>


                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeDetallePerfilador(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                        
                        

                    </div>
                    </div>
                </div>
                <ModalMultimedia class="divGestorArchivosDetPerfilador" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}
